import { Component, OnInit, Input } from '@angular/core';
import { HelperService } from '../../../services/helper.service';

@Component({
  selector: 'app-ju-page-header',
  templateUrl: './ju-page-header.component.html',
  styleUrls: ['./ju-page-header.component.css']
})
export class JuPageHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() small: string;
  @Input() teamLogo: string;
  @Input() links = [];

  constructor(
    private helperService: HelperService
  ) {
  }

  ngOnInit() {
  }

  setLogo(url) {
    return this.helperService.setClubLogo(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/ju-page-header/ju-page-header.component.ts